import { css } from '@emotion/react'
import { Cell, Grid, HeadingSection, HFlow, InfoLabel, Theme, useTheme } from 'bold-ui'
import { booleanToSimNaoEnum, simNaoEnumRecord } from 'components/form'
import { HLabel } from 'components/HLabel'
import { InfoIcon } from 'components/InfoIcon'
import { VulnerabilidadeFamiliar } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'

import { VulnerabilidadeFamiliarProntuarioPanel } from './VulnerabilidadeFamiliarProntuarioPanel'

export interface ClassificacaoVulnerabilidadeSectionProps {
  isBeneficiarioBolsaFamilia?: boolean
  dataRegistroInsegurancaAlimentar?: string
  vulnerabilidadeFamiliar?: VulnerabilidadeFamiliar
  bolsaFamiliaTooltipText?: string
}

export const ClassificacaoVulnerabilidadeSection = ({
  isBeneficiarioBolsaFamilia,
  dataRegistroInsegurancaAlimentar,
  vulnerabilidadeFamiliar,
  bolsaFamiliaTooltipText,
}: Readonly<ClassificacaoVulnerabilidadeSectionProps>) => {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <HeadingSection level={2} title='Acompanhamento de vulnerabilidade'>
      <Grid wrap gapVertical={1.5}>
        {dataRegistroInsegurancaAlimentar && (
          <Cell size={6}>
            <InfoLabel title='Triagem para Risco de Insegurança Alimentar'>
              {formatDate(dataRegistroInsegurancaAlimentar)}
            </InfoLabel>
          </Cell>
        )}
        {isBeneficiarioBolsaFamilia && (
          <Cell size={6}>
            <HLabel
              title={
                <HFlow hSpacing={0.25} alignItems='center'>
                  Beneficiário do programa Bolsa Família
                  {bolsaFamiliaTooltipText && (
                    <InfoIcon icon='infoCircleFilled' text={bolsaFamiliaTooltipText} css={styles.infoIcon} />
                  )}
                </HFlow>
              }
            >
              {simNaoEnumRecord[booleanToSimNaoEnum(isBeneficiarioBolsaFamilia)]}
            </HLabel>
          </Cell>
        )}

        {vulnerabilidadeFamiliar?.classificacao && (
          <Cell size={12}>
            <VulnerabilidadeFamiliarProntuarioPanel vulnerabilidadeFamiliar={vulnerabilidadeFamiliar} />
          </Cell>
        )}
      </Grid>
    </HeadingSection>
  )
}

const createStyles = (theme: Theme) => ({
  infoIcon: css`
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.25rem;
    width: 1rem;
    height: 1rem;
    font-size: 1rem;
    color: ${theme.pallete.text.main};
  `,
})
